<template>
  <router-link :to="routeTo">
    <div
      class="mb-3 card card-body commercial-card"
      :style="{'background-image': imagePath}"
      @mouseenter="mouseOver = true"
      @mouseleave="mouseOver = false"
    >
      <div class="commercial-card-inner">
        <div
          class="commercial-title"
          :class="{'commercial-title-hover': mouseOver}"
        >
          {{ $tc(`word.${slug}_commercial`, 1) }}
          <transition name="fade">
            <div
              v-if="mouseOver"
              class="commercial-subtitle d-flex justify-content-center align-items-center"
            >
              {{ $t(`sentence.register_${slug}_commercial`) }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'RegisterCommercialOption',
  props: {
    imagePath: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    isPublic: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
  },
  data() {
    return {
      mouseOver: false,
    };
  },
  computed: {
    routeTo() {
      if (this.isPublic) {
        if (this.slug === 'other') {
          return { name: 'organisation-request-research' };
        }
        if (this.slug === 'dooh') {
          return { name: 'public-register-commercial', query: { commercialType: 'ooh' } };
        }
        return { name: 'public-register-commercial', query: { commercialType: this.slug } };
      }

      if (this.slug === 'other') {
        return { name: 'organisation-request-research' };
      }
      if (this.slug === 'dooh') {
        return { name: 'organisation-register-research-start', query: { commercialType: 'ooh' } };
      }
      return { name: 'organisation-register-research-start', query: { commercialType: this.slug } };
    },
  },
};
</script>


<style scoped>
.commercial-card {
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70%;
  padding: 40%;
  box-sizing: border-box;
  position: relative;
}

.commercial-card-inner {
  transition: all .5s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.commercial-card-inner:hover {
  background: rgba(0, 0, 0, 0.6);
}

.commercial-title {
  position: absolute;
  transition: all 0.5s ease-out;;
  bottom: 0;
  left: 0;
  font-size: 20px;
  background: rgba(0, 0, 0, 0.6);
  padding: 10px;
  color: white;
  width: 100%;
  text-align: center;
}

.commercial-title-hover {
  transform: translateY(-50px);
  background: none;
}

.commercial-subtitle {
  position: absolute;
  bottom: -50px;
  left: 0;
  color: white;
  height: 60px;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  font-size: 12px;
}
</style>
